/* eslint-disable camelcase */
import add_user from "./assets/add_user.svg";
import aggregation_avg from "./assets/aggregation_avg.svg";
import aggregation_max from "./assets/aggregation_max.svg";
import aggregation_med from "./assets/aggregation_med.svg";
import aggregation_min from "./assets/aggregation_min.svg";
import aggregation_sum from "./assets/aggregation_sum.svg";
import aggregation_sum_abs from "./assets/aggregation_sum_abs.svg";
import alarm from "./assets/alarm.svg";
import alarmCritical from "./assets/alarm_c.svg";
import alarmCriticalWarning from "./assets/alarm_cw.svg";
import alarmWarning from "./assets/alarm_w.svg";
import alarm_bell from "./assets/alarm_bell.svg";
import alarms_new from "./assets/alarms_new.svg";
import around_clock from "./assets/around_clock.svg";
import arrow_down from "./assets/arrow_down.svg";
import arrow_left from "./assets/arrow_left.svg";
import arrow_s_down from "./assets/arrow-s_down.svg";
import arrow_s_left from "./assets/arrow-s_left.svg";
import arrows_vertical from "./assets/arrows_vertical.svg";
import bookmark from "./assets/bookmark.svg";
import bullet_one from "./assets/bullet_one.svg";
import bullet_three from "./assets/bullet_three.svg";
import bullet_two from "./assets/bullet_two.svg";
import chart_added from "./assets/chart_added.svg";
import charts from "./assets/charts.svg";
import check from "./assets/check.svg";
import checkmark_partial_s from "./assets/checkmark_partial_s.svg";
import checkmark_s from "./assets/checkmark_s.svg";
import chevron_double from "./assets/chevron_double.svg";
import chevron_down from "./assets/chevron_down.svg";
import chevron_left from "./assets/chevron_left.svg";
import chevron_right_s from "./assets/chevron_right_s.svg";
import classError from "./assets/class_error.svg";
import classLatency from "./assets/class_latency.svg";
import classUtilization from "./assets/class_utilization.svg";
import classWorkload from "./assets/class_workload.svg";
import cluster from "./assets/cluster.svg";
import cluster_spaces from "./assets/cluster_spaces.svg";
import code from "./assets/code.svg";
import collapse from "./assets/collapse.svg";
import community from "./assets/community.svg";
import container from "./assets/container.svg";
import controller_kind from "./assets/controller_kind.svg";
import controller_name from "./assets/controller_name.svg";
import copy from "./assets/copy.svg";
import correlation from "./assets/correlation.svg";
import correlation_inv from "./assets/correlation_inv.svg";
import cross_s from "./assets/cross_s.svg";
import dashboard from "./assets/dashboard.svg";
import dashboard_add from "./assets/dashboard_add.svg";
import dashboards from "./assets/dashboards.svg";
import documentation from "./assets/documentation.svg";
import dot from "./assets/dot.svg";
import dots_2x3 from "./assets/dots_2x3.svg";
import download from "./assets/download.svg";
import error from "./assets/error.svg";
import expand from "./assets/expand.svg";
import filterList from "./assets/filterList.svg";
import forcePlay from "./assets/force_play.svg";
import forcePlayOutline from "./assets/force_play_outline.svg";
import gear from "./assets/gear.svg";
import github from "./assets/github.svg";
import google from "./assets/google.svg";
import hamburger from "./assets/hamburger.svg";
import help from "./assets/help.svg";
import hide from "./assets/hide.svg";
import holder from "./assets/holder.svg";
import insights from "./assets/insights.svg";
import line_chart from "./assets/line_chart.svg";
import logo_s from "./assets/logo_s.svg";
import magnify from "./assets/magnify.svg";
import more from "./assets/more.svg";
import navLeft from "./assets/nav_left.svg";
import navRight from "./assets/nav_right.svg";
import nav_arrow_goto from "./assets/nav_arrow_goto.svg";
import nav_dots from "./assets/nav_dots.svg";
import node from "./assets/node.svg";
import node_child from "./assets/node_child.svg";
import node_default_l from "./assets/node_default_l.svg";
import node_hollow from "./assets/node_hollow.svg";
import node_import_export from "./assets/node_import_export.svg";
import node_notification_l from "./assets/node_notification_l.svg";
import node_parent from "./assets/node_parent.svg";
import node_selected_l from "./assets/node_selected_l.svg";
import nodes from "./assets/nodes.svg";
import nodes_hollow from "./assets/nodes_hollow.svg";
import none_selected from "./assets/none_selected.svg";
import notification from "./assets/notification.svg";
import padlock from "./assets/padlock.svg";
import pauseOutline from "./assets/pause_outline.svg";
import pauseSolid from "./assets/pause_solid.svg";
import pencil from "./assets/pencil.svg";
import pin_element from "./assets/pin_element.svg";
import playOutline from "./assets/play_outline.svg";
import playSolid from "./assets/play_solid.svg";
import plus from "./assets/plus.svg";
import plus_mini_s from "./assets/plus_mini_s.svg";
import pod from "./assets/pod.svg";
import print from "./assets/print.svg";
import question from "./assets/question.svg";
import questionFilled from "./assets/questionFilled.svg";
import reload from "./assets/reload.svg";
import room from "./assets/room.svg";
import room_new from "./assets/room_new.svg";
import room_overview from "./assets/room_overview.svg";
import sad from "./assets/sad.svg";
import save from "./assets/save.svg";
import search_s from "./assets/search_s.svg";
import services from "./assets/services.svg";
import settings from "./assets/settings.svg";
import settings_h from "./assets/settings_h.svg";
import sorting_vertical from "./assets/sorting_vertical.svg";
import space from "./assets/space.svg";
import space_new from "./assets/space_new.svg";
import switch_off from "./assets/switch_off.svg";
import system_overview from "./assets/system_overview.svg";
import text_add from "./assets/text_add.svg";
import thumb_down from "./assets/thumb_down.svg";
import thumb_up from "./assets/thumb_up.svg";
import trashcan from "./assets/trashcan.svg";
import triangle from "./assets/triangle.svg";
import triangle_down from "./assets/triangle_down.svg";
import unknownError from "./assets/unknownError.svg";
import unreachable from "./assets/unreachable.svg";
import update from "./assets/update.svg";
import update_pending from "./assets/update_pending.svg";
import upload from "./assets/upload.svg";
import user from "./assets/user.svg";
import users from "./assets/users.svg";
import view_list from "./assets/view_list.svg";
import warning from "./assets/warning.svg";
import warning_triangle from "./assets/warning_triangle.svg";
import x from "./assets/x.svg";
import firewallSolid from "./assets/firewall_solid.svg";
import qualityOfServiceSolid from "./assets/qualityOfService_solid.svg";
import applicationsSolid from "./assets/applications_solid.svg";
import networkingStack from "./assets/networking_stack.svg";
export var iconsList = {
    add_user: add_user,
    aggregation_avg: aggregation_avg,
    aggregation_max: aggregation_max,
    aggregation_med: aggregation_med,
    aggregation_min: aggregation_min,
    aggregation_sum: aggregation_sum,
    aggregation_sum_abs: aggregation_sum_abs,
    alarm: alarm,
    alarmCritical: alarmCritical,
    alarmCriticalWarning: alarmCriticalWarning,
    alarmWarning: alarmWarning,
    alarm_bell: alarm_bell,
    alarms_new: alarms_new,
    applicationsSolid: applicationsSolid,
    around_clock: around_clock,
    arrow_down: arrow_down,
    arrow_left: arrow_left,
    arrow_s_down: arrow_s_down,
    arrow_s_left: arrow_s_left,
    arrows_vertical: arrows_vertical,
    bookmark: bookmark,
    bullet_one: bullet_one,
    bullet_three: bullet_three,
    bullet_two: bullet_two,
    chart_added: chart_added,
    charts: charts,
    check: check,
    checkmark_partial_s: checkmark_partial_s,
    checkmark_s: checkmark_s,
    chevron_double: chevron_double,
    chevron_down: chevron_down,
    chevron_left: chevron_left,
    chevron_right_s: chevron_right_s,
    classError: classError,
    classLatency: classLatency,
    classUtilization: classUtilization,
    classWorkload: classWorkload,
    cluster: cluster,
    cluster_spaces: cluster_spaces,
    code: code,
    collapse: collapse,
    community: community,
    container: container,
    controller_kind: controller_kind,
    controller_name: controller_name,
    copy: copy,
    correlation: correlation,
    correlation_inv: correlation_inv,
    cross_s: cross_s,
    dashboard: dashboard,
    dashboard_add: dashboard_add,
    dashboards: dashboards,
    documentation: documentation,
    dot: dot,
    dots_2x3: dots_2x3,
    download: download,
    error: error,
    expand: expand,
    filterList: filterList,
    firewallSolid: firewallSolid,
    forcePlay: forcePlay,
    forcePlayOutline: forcePlayOutline,
    gear: gear,
    github: github,
    google: google,
    hamburger: hamburger,
    help: help,
    hide: hide,
    holder: holder,
    insights: insights,
    line_chart: line_chart,
    logo_s: logo_s,
    magnify: magnify,
    more: more,
    navLeft: navLeft,
    navRight: navRight,
    nav_arrow_goto: nav_arrow_goto,
    nav_dots: nav_dots,
    networkingStack: networkingStack,
    node: node,
    node_child: node_child,
    node_default_l: node_default_l,
    node_hollow: node_hollow,
    node_import_export: node_import_export,
    node_notification_l: node_notification_l,
    node_parent: node_parent,
    node_selected_l: node_selected_l,
    nodes: nodes,
    nodes_hollow: nodes_hollow,
    none_selected: none_selected,
    notification: notification,
    padlock: padlock,
    pauseOutline: pauseOutline,
    pauseSolid: pauseSolid,
    pencil: pencil,
    pin_element: pin_element,
    playOutline: playOutline,
    playSolid: playSolid,
    plus: plus,
    plus_mini_s: plus_mini_s,
    pod: pod,
    print: print,
    qualityOfServiceSolid: qualityOfServiceSolid,
    question: question,
    questionFilled: questionFilled,
    reload: reload,
    room: room,
    room_new: room_new,
    room_overview: room_overview,
    sad: sad,
    save: save,
    search_s: search_s,
    services: services,
    settings: settings,
    settings_h: settings_h,
    sorting_vertical: sorting_vertical,
    space: space,
    space_new: space_new,
    switch_off: switch_off,
    system_overview: system_overview,
    text_add: text_add,
    thumb_down: thumb_down,
    thumb_up: thumb_up,
    trashcan: trashcan,
    triangle: triangle,
    triangle_down: triangle_down,
    unknownError: unknownError,
    unreachable: unreachable,
    update: update,
    update_pending: update_pending,
    upload: upload,
    user: user,
    users: users,
    view_list: view_list,
    warning: warning,
    warning_triangle: warning_triangle,
    x: x,
};
